module.exports = __webpack_public_path__ + "img/mobi_P4.3a91ef72.png";